import { render, staticRenderFns } from "./yufu_list.vue?vue&type=template&id=fda6308a&scoped=true&"
import script from "./yufu_list.vue?vue&type=script&lang=js&"
export * from "./yufu_list.vue?vue&type=script&lang=js&"
import style0 from "./yufu_list.vue?vue&type=style&index=0&id=fda6308a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda6308a",
  null
  
)

export default component.exports